import * as React from 'react';
import {Component, CSSProperties} from 'react';

import CommentWrapStore from './commentWrap.store';
import CommentWrap from './commentWrap';

interface IContainerProps {
  className?: string;
  style?: CSSProperties;
}

interface IContainerInjectProps extends IContainerProps {
  commentWrapStore: CommentWrapStore;
}

interface IContainerState {
}

const stats = {};

export default class Container extends Component<IContainerProps, IContainerState> {
  constructor(props) {
    super(props);
  }

  public get injected() {
    return this.props as IContainerInjectProps;
  }

  public render() {
    const commentWrapStore: CommentWrapStore = this.injected.commentWrapStore;
    // console.log('Container shareLineStore', shareLineStore);

    return <CommentWrap  shouldShowComment={commentWrapStore.shouldShowComment}/>;

  }
}
